export const HOME_PAGE_VIDEO = 'https://www.youtube.com/watch?v=O4lxQHdssyE';
export const DELIVERY_DASH_VIDEO = 'https://youtu.be/KSkuQYCfrck';
export const LICHESS_VIDEO = 'https://www.youtube.com/watch?v=_4KBwhbbR0Y';
export const LIDRAUGHTS_VIDEO = 'https://www.youtube.com/watch?v=mpv8DVH-Fqs';
export const BLOCKTRIS_VIDEO = 'https://www.youtube.com/watch?v=ZJfYPWac6E8';
export const EV_IO_VIDEO = 'https://www.youtube.com/watch?v=ESaW2zJr34M';
